import React from "react";

const columns = () => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden",
      },
    },
    {
      title: "任务名称",
      name: "name",
      dataIndex: "name",
      tableItem: {
        width: 200
      },
      formItem: {},
      searchItem: {},
    },
    {
      title: "业务类型",
      name: "bizType",
      dataIndex: "bizType",
      tableItem: {
        width: 100
      },
      dict: [
        { code: 0, codeName: "课程" },
        { code: 1, codeName: "考试" },
        { code: 26, codeName: "直播" },
        { code: 15, codeName: "报名" },
        {code: 45, codeName: '班级环节'},
      ],
      searchItem: {
        type: "select",
      },
    },
    // {
    //   title: "重要程度",
    //   name: "importance",
    //   dataIndex: "importance",
    //   tableItem: {
    //     width: 100
    //   },
    //   dict: [
    //     { code: 0, codeName: "重要" },
    //     { code: 1, codeName: "一般" },
    //   ],
    //   searchItem: {
    //     type: "select",
    //   },
    // },
    {
      title: "开始时间",
      name: "startDate",
      dataIndex: "startDate",
      tableItem: {
        width: 150
      },
    },
    {
      title: "结束时间",
      name: "endDate",
      dataIndex: "endDate",
      tableItem: {
        width: 150
      },
    },
    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      tableItem: {
        width: 100
      },
      dict: [
        { code: 0, codeName: "未开始" },
        { code: 1, codeName: "执行中" },
        { code: 2, codeName: "已结束" },
        { code: 3, codeName: "已取消" },
      ],
      searchItem: {
        type: "select",
      },
    },
    // {
    //   title: "任务来源",
    //   name: "source",
    //   dataIndex: "source",
    //   tableItem: {
    //     width: 120
    //   },
    //   dict: [
    //     { code: 0, codeName: "统一平台" },
    //     { code: 1, codeName: "第三方系统" },
    //   ],
    //   searchItem: {
    //     type: "select",
    //   },
    // },
    {
      title: "是否消息通知",
      dict: [
        { code: 0, codeName: "否" },
        { code: 1, codeName: "是" },
      ],
      name: "needNotice",
      dataIndex: "needNotice",
      tableItem: {
        width: 150
      },
    },
    {
      title: "任务时间",
      name: "time",
      dataIndex: "time",
      searchItem: {
        type: "date~",
      },
    },
  ];
};

const tableApi = (api = {}) => {
  return {
    path: "taskInfo/listByPage",
    ...api,
  };
};

const task = (self, api) => {
  return {
    type: "diy",
    initialValue: [],
    rowkey: "id",
    rowName: "name",
    columns: columns(),
    tableApi: tableApi(api),
  };
};

export default task;
